<script setup lang="ts">
import type { Plan } from "@/lib/types";
import { RadioGroupItem } from "@/components/ui/radio-group";
import { Badge } from "@/components/ui/badge";

interface Props {
  plan: Plan;
  selected: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  select: [value: string];
}>();
</script>

<template>
  <div
    :class="[
      'cursor-pointer border-2 bg-input/30 hover:bg-input/50 p-4 transition-all duration-200 flex flex-col rounded-xl h-44 brand-card-shadow',
      selected ? 'border-white shadow-lg' : 'border-transparent',
    ]"
    @click="emit('select', plan.packageCode)"
  >
    <div class="flex justify-between items-start mb-2">
      <RadioGroupItem :value="plan.packageCode" :id="plan.packageCode" />
      <Badge class="text-xs brand-button-shadow">{{ plan.duration }} days</Badge>
    </div>

    <h3 class="text-2xl font-semibold text-white mb-1">{{ plan.gb }} GB</h3>

    <p class="text-xl font-bold mt-auto">${{ plan.price.toFixed(2) }}</p>
  </div>
</template>
